import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CHANGE_MEMBERSHIP, CHANGE_MEMBERSHIP_SUCCESS, CHANGE_MEMBERSHIP_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* changeMembership({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { user_id } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${user_id}/update-membership`,
      method: 'PUT',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CHANGE_MEMBERSHIP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CHANGE_MEMBERSHIP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CHANGE_MEMBERSHIP_ERROR, payload: error });
  }
}

export function* watchChangeMembership() {
  yield takeEvery(CHANGE_MEMBERSHIP, changeMembership);
}

function* changeMembershipSaga() {
  yield all([fork(watchChangeMembership)]);
}

export default changeMembershipSaga;
